(() => {
  const root = document.documentElement;
  const body = document.body;
  const money = (cents) => {
    const format = window.Funkar?.moneyFormat || 'Rs {{amount}}';
    const value = (Number(cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  };

  const lock = () => body.classList.add('is-locked');
  const unlock = () => { if (!document.querySelector('.is-open')) body.classList.remove('is-locked'); };
  const openDrawer = (drawer) => { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); lock(); drawer.querySelector('button, input, a')?.focus(); };
  const closeDrawer = (drawer) => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); setTimeout(unlock, 20); };
  const showHeroSlide = (hero, requestedIndex) => {
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    if (!slides.length) return;
    const index = (Number(requestedIndex) + slides.length) % slides.length;
    slides.forEach((slide, position) => {
      const active = position === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    dots.forEach((dot, position) => {
      const active = position === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', String(active));
    });
    hero.dataset.heroIndex = String(index);
  };

  document.addEventListener('click', (event) => {
    const heroDot = event.target.closest('[data-hero-dot]');
    if (heroDot) {
      const hero = heroDot.closest('[data-hero-slider]');
      if (hero) showHeroSlide(hero, heroDot.dataset.heroDot);
      return;
    }
    const gridButton = event.target.closest('[data-grid-size]');
    if (gridButton) {
      const grid = document.querySelector('[data-collection-grid]');
      document.querySelectorAll('[data-grid-size]').forEach(button => button.setAttribute('aria-pressed', String(button === gridButton)));
      grid?.classList.toggle('product-grid--three', gridButton.dataset.gridSize === 'three');
      return;
    }
    const mediaButton = event.target.closest('[data-media-target]');
    if (mediaButton) {
      const target = document.getElementById(mediaButton.dataset.mediaTarget);
      const track = target?.parentElement;
      if (target && track) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      mediaButton.parentElement.querySelectorAll('[data-media-target]').forEach(button => button.classList.toggle('is-active', button === mediaButton));
      return;
    }
    const wishlistButton = event.target.closest('[data-wishlist-toggle]');
    if (wishlistButton) {
      const isSaved = wishlistButton.getAttribute('aria-pressed') !== 'true';
      wishlistButton.setAttribute('aria-pressed', String(isSaved));
      wishlistButton.innerHTML = `<span aria-hidden="true">${isSaved ? '♥' : '♡'}</span> ${isSaved ? 'Saved' : 'Save to wishlist'}`;
      return;
    }
    const trendingTab = event.target.closest('[data-trending-tab]');
    if (trendingTab) {
      const section = trendingTab.closest('.trending');
      section.querySelectorAll('[data-trending-tab]').forEach(tab => tab.setAttribute('aria-selected', String(tab === trendingTab)));
      section.querySelectorAll('[data-trending-panel]').forEach(panel => panel.hidden = panel.dataset.trendingPanel !== trendingTab.dataset.trendingTab);
      return;
    }
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) { event.preventDefault(); openDrawer(document.querySelector(opener.dataset.drawerOpen)); return; }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) { event.preventDefault(); closeDrawer(closer.closest('.mobile-drawer,.search-drawer,.cart-drawer')); return; }
    const qty = event.target.closest('[data-qty-button]');
    if (qty) {
      const input = qty.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value || 1) + Number(qty.dataset.qtyButton));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.is-open').forEach(closeDrawer);
  });

  const updateCartCount = async () => {
    const cart = await fetch('/cart.js').then(r => r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  };
  const refreshCartDrawer = async (open = true) => {
    const html = await fetch('/?section_id=fk-cart-drawer').then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('#FunkarCartDrawer');
    const current = document.querySelector('#FunkarCartDrawer');
    if (incoming && current) current.replaceWith(incoming);
    await updateCartCount();
    if (open) openDrawer(document.querySelector('#FunkarCartDrawer'));
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-product-status]');
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this item.');
      if (status) status.textContent = '';
      await refreshCartDrawer(true);
    } catch (error) { if (status) status.textContent = error.message; }
    finally { button.disabled = false; button.textContent = button.dataset.label || 'Add to bag'; }
  });

  document.addEventListener('change', async (event) => {
    if (event.target.matches('[data-auto-submit]')) event.target.form?.submit();
    if (event.target.matches('[data-cart-line-quantity]')) {
      const line = event.target.dataset.cartLineQuantity;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: Number(event.target.value) }) });
      await refreshCartDrawer(true);
    }
    const form = event.target.closest('[data-product-form]');
    if (form && event.target.matches('[data-option-value]')) {
      const options = [...form.querySelectorAll('[data-option-group]')].map(group => group.querySelector('[data-option-value]:checked')?.value);
      const variants = JSON.parse(form.querySelector('[data-product-json]').textContent);
      const variant = variants.find(v => v.options.every((value, i) => value === options[i]));
      const id = form.querySelector('[name="id"]');
      const add = form.querySelector('[type="submit"]');
      const price = document.querySelector('[data-product-price]');
      const stock = document.querySelector('[data-stock-badge]');
      if (variant) {
        id.value = variant.id; add.disabled = !variant.available; add.textContent = variant.available ? add.dataset.label : 'Sold out';
        if (price) price.textContent = money(variant.price);
        if (stock) { stock.textContent = variant.available ? 'In Stock' : 'Sold Out'; stock.classList.toggle('is-sold-out', !variant.available); }
        history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      }
    }
  });

  document.querySelectorAll('[data-hero-slider]').forEach(hero => {
    let timer;
    const play = () => {
      clearInterval(timer);
      timer = setInterval(() => showHeroSlide(hero, Number(hero.dataset.heroIndex || 0) + 1), 7000);
    };
    const pause = () => clearInterval(timer);
    hero.dataset.heroIndex = '0';
    hero.addEventListener('mouseenter', pause);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', pause);
    hero.addEventListener('focusout', play);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));
  } else document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('is-visible'));
})();

/* ============ FUNKAR motion + speed layer ============ */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;
  root.classList.add('fk-motion');
  if (document.startViewTransition) root.classList.add('fk-vt');

  /* -- scroll reveals: tag content inside each section, stagger siblings -- */
  const REVEAL = '.product-card, .category-panel, .colour-card, .trending article, .section-heading, .craft__copy, .mommy__copy, .intro__copy, .newsletter__inner, .duo__panel, h2, .fk-lede';
  const MEDIA = '.craft__media, .mommy__media, .duo__panel';
  if (!reduced && 'IntersectionObserver' in window) {
    const secObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('fk-in'); secObserver.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });

    document.querySelectorAll('main .shopify-section > section, main .shopify-section > div').forEach((section) => {
      if (section.closest('.hero--campaign') || section.querySelector('.hero--campaign')) return;
      let i = 0;
      section.querySelectorAll(REVEAL).forEach((el) => {
        if (el.closest('.fk-r')) return;
        el.classList.add('fk-r');
        if (el.matches(MEDIA)) el.classList.add('fk-r--media');
        el.style.setProperty('--fk-d', String(Math.min(i, 6)));
        i += 1;
      });
      if (i) { section.classList.add('fk-sec'); secObserver.observe(section); }
    });

    /* fail-safe: if the observer misses (old browsers, edge states), reveal
       anything on screen on scroll, and reveal everything after 6s idle-below-fold */
    const revealInView = () => document.querySelectorAll('.fk-sec:not(.fk-in)').forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.94 && rect.bottom > 0) section.classList.add('fk-in');
    });
    window.addEventListener('scroll', revealInView, { passive: true });
    window.addEventListener('load', revealInView);
    setTimeout(revealInView, 800);
  }

  /* -- header: shadow when scrolled, hide on scroll down, show on scroll up -- */
  let lastY = window.scrollY;
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      document.body.classList.toggle('fk-scrolled', y > 24);
      if (Math.abs(y - lastY) > 8) {
        document.body.classList.toggle('fk-scroll-down', y > lastY && y > 320);
        lastY = y;
      }
      ticking = false;
    });
  }, { passive: true });

  /* -- leave fade for browsers without cross-document view transitions -- */
  if (!document.startViewTransition && !reduced) {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname === location.pathname) return;
      if (url.pathname.startsWith('/cart') || url.pathname.startsWith('/checkout')) return;
      event.preventDefault();
      document.body.classList.add('fk-leaving');
      setTimeout(() => { location.href = url.href; }, 200);
    });
    window.addEventListener('pageshow', () => document.body.classList.remove('fk-leaving'));
  }

  /* -- speed: prefetch next pages the moment intent shows -- */
  const prefetched = new Set();
  const prefetch = (href) => {
    try {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin || prefetched.has(url.pathname)) return;
      if (!/^\/(products|collections|pages|blogs)\//.test(url.pathname) && url.pathname !== '/') return;
      prefetched.add(url.pathname);
      const tag = document.createElement('link');
      tag.rel = 'prefetch';
      tag.href = url.pathname + url.search;
      document.head.appendChild(tag);
    } catch (e) { /* ignore malformed URLs */ }
  };
  ['pointerover', 'touchstart'].forEach((type) => document.addEventListener(type, (event) => {
    const link = event.target.closest('a[href]');
    if (link) prefetch(link.href);
  }, { passive: true, capture: true }));
})();
